import { render, staticRenderFns } from "./RedirectToAppView.vue?vue&type=template&id=03ace3b0"
import script from "./RedirectToAppView.vue?vue&type=script&setup=true&lang=js"
export * from "./RedirectToAppView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedirectToAppView.vue?vue&type=style&index=0&id=03ace3b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports